const STORAGE_KEY = "web3:invite-code"

/** Trim + uppercase for consistent storage and API payloads. */
export function normalizeInviteCode(raw: string): string {
  return raw.trim().toUpperCase()
}

/**
 * Read `?ref=` from the current URL, persist to sessionStorage when present,
 * and return the normalized code (or null if the URL has no ref).
 */
export function captureRefFromUrl(): string | null {
  if (typeof window === "undefined") return null
  try {
    const params = new URLSearchParams(window.location.search)
    const raw = params.get("ref")
    if (!raw || !raw.trim()) return null
    const code = normalizeInviteCode(raw)
    if (code.length < 4) return null
    sessionStorage.setItem(STORAGE_KEY, code)
    return code
  } catch {
    return null
  }
}

/**
 * Resolve invite code: URL `?ref=` (highest) → sessionStorage → VITE_AGENT_ID
 * (legacy / local-dev fallback; prefer invite codes in production).
 */
export function getInviteCode(): string {
  const fromUrl = captureRefFromUrl()
  if (fromUrl) return fromUrl

  if (typeof sessionStorage !== "undefined") {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      if (stored && stored.trim()) return normalizeInviteCode(stored)
    } catch {
      // ignore storage errors
    }
  }

  const fallback = import.meta.env.VITE_AGENT_ID?.trim() ?? ""
  return fallback
}
